module.exports = __webpack_public_path__ + "media/images/guide-thumb-6t-ae4944acb53f8c36dcecbfb02378d1ee.png";